/* eslint-disable jsx-a11y/alt-text */
import React, { useCallback, useMemo } from "react";
import downloadIcon from "../../assets/download-icon.svg";
import { Filesystem } from "@capacitor/filesystem";
import { Toast } from "@capacitor/toast";
import Constants from "../../constants";
import { FaTimes } from "react-icons/fa";

import { Media } from "@capacitor-community/media";
import { Capacitor } from "@capacitor/core";
import ImageComponent from "../../Layout/LoggedInLayout/ImageComponent";

const ensureDemoAlbum = async () => {
  let { albums } = await Media.getAlbums();
  const albumName = "Footprints Album";
  let demoAlbum = undefined;
  if (Capacitor.getPlatform() === "android") {
    const albumsPath = (await Media.getAlbumsPath()).path;
    demoAlbum = albums.find(
      (a) => a.name === albumName && a.identifier.startsWith(albumsPath)
    );
  } else {
    demoAlbum = albums.find((a) => a.name === albumName);
  }

  if (!demoAlbum) {
    // Doesn't exist, create new album
    await Media.createAlbum({ name: albumName });
    albums = await Media.getAlbums();
    demoAlbum = albums.albums.find((a) => a.name === albumName);
  }

  const message = demoAlbum
    ? "Image downloaded successfully"
    : "Image download failed";
  Toast.show({ text: message, duration: "short" });

  return demoAlbum ? demoAlbum.identifier : "";
};

const DownloadImageMobile = async (fileName, base64Data) => {
  // let result = await Filesystem.writeFile({
  //   path: fileName,
  //   data: base64Data,
  //   directory: Directory.Documents,
  //   recursive: true,
  // });

  // const message = result
  //   ? 'Image downloaded successfully'
  //   : 'Image download failed';
  // Toast.show({ text: message, duration: 'short' });
  const image = await Media.savePhoto({
    path: base64Data,
    albumIdentifier: await ensureDemoAlbum(),
    fileName,
  });

  return image;
};

const ImageDownloader = ({
  disableCache = true,
  buttonText = "Download",
  imageUrl = "",
  component,
  closeLightbox,
}) => {
  console.log("inside download");
  const convertBlobToBase64 = (blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  const downloadImage = useCallback(
    async (e) => {
      if (e.preventDefault) {
        e.preventDefault();
      }

      if (!imageUrl.length) {
        return;
      }
      try {
        const fetchUrl = `${e.target.href}${
          disableCache ? `?dummy=${Math.floor(Date.now())}` : ""
        }`;

        const response = await fetch(fetchUrl);
        const blob = await response.blob();
        const base64Data = await convertBlobToBase64(blob);

        const timestamp = new Date().getTime();
        const fileName = `image_${timestamp}.png`;
        const permissionStatus = await Filesystem.checkPermissions();

        if (permissionStatus.publicStorage === "granted") {
          DownloadImageMobile(fileName, base64Data);
        } else {
          await Filesystem.requestPermissions().then(async (requestStatus) => {
            if (requestStatus.publicStorage === "granted") {
              DownloadImageMobile(fileName, base64Data);
            } else {
              Toast.show({
                text: "Permission denied, please enable it manually",
                duration: "long",
              });
            }
          });
        }
      } catch (error) {
        console.error("Error downloading image:", error);
        Toast.show({
          text: "Error downloading image",
          duration: "short",
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disableCache]
  );

  const onButtonClick = useCallback(
    (e) => {
      if (e.preventDefault) {
        e.preventDefault();
      }

      if (!imageUrl.length) {
        console.log("Please add an image url");
        return;
      }

      const fetchUrl = `${e.target.href}${
        disableCache ? `?dummy=${Math.floor(Date.now())}` : ""
      }`;

      fetch(fetchUrl, {
        method: "GET",
        headers: {},
      })
        .then((response) => {
          response.arrayBuffer().then(function (buffer) {
            const url = window.URL.createObjectURL(new Blob([buffer]));
            const link = document.createElement("a");

            link.href = url;
            link.setAttribute(
              "download",
              imageUrl.substr(imageUrl.lastIndexOf("/") + 1)
            );
            document.body.appendChild(link);
            link.click();
          });
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [disableCache]
  );

  return useMemo(
    () => (
      <div className="container">
        <ImageComponent
          src={imageUrl}
          className={"m-0 border-0 bg-white rounded-md"}
          variant="lightbox"
          profile={false}
        />
        <div className="flex justify-center items-center mt-3 gap-2">
          <a
            className="bg-white rounded-full p-1 w-8 h-8 flex justify-center items-center  border-2 shadow-9"
            href={imageUrl}
            download
            onClick={(e) =>
              Constants.env.web === "yes" ? onButtonClick(e) : downloadImage(e)
            }
            style={{ width: "30px" }}
          >
            <img src={downloadIcon} height={32} />
          </a>
          {component}
        </div>
        <div
          className="inset-0 mx-auto mt-2 mb-2 bg-white h-12 w-12 rounded-full flex items-center justify-center border-2 shadow-9"
          onClick={closeLightbox}
        >
          <FaTimes
            className="m-auto"
            style={{ color: "#4267B2", fontSize: 25 }}
          />
        </div>
      </div>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [imageUrl, buttonText]
  );
};

export default ImageDownloader;
